<template>
  <div class="manager-holding-timeline">
    <slot></slot>
    <ul class="timeline-wrapper edge-padding">
      <li class="item" v-for="item in data" :key="item.name">
        <div class="left">
          <p class="day">{{ item.reportDate?.slice(5, 10) }}</p>
          <p class="year">{{ item.reportDate?.slice(0, 4) }}</p>
        </div>
        <div class="right">
          <div class="name-position">
            <span class="name">{{ item.holderName }}</span>
            <span class="main-info">{{ item.position ?? item.managerPost }}</span>
          </div>
          <div class="overweight">
            <span v-if="market === 'hk'">{{ $t('持仓类型') }}：{{ item.holdingType }}，</span>
            <span>
              {{ $t('本次持仓变动') }}：
              <span :style="{ color: $digitjs(item.changeNumber).colour({ flat: 'inherit' }).color() }">
                {{ $digitjs(item.changeNumber).unit('股').convert() }}
              </span>
            </span>
            <span>，{{ $t('变动后剩余') }}{{ $digitjs(item.holdingNumber).unit('股').convert() }}</span>
            <!-- <span>，持股比例为{{ $digitjs(item.holdingRatio).unit('%').rounded() }}</span> -->
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['data'],
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  }
}
</script>

<style lang="scss" scoped>
.manager-holding-timeline {
  background: var(--bg-color-2);
}
.timeline-wrapper {
  .item {
    display: flex;
    align-items: stretch;
    .left {
      position: relative;
      width: 56px;
      border-right: 1px solid #fbe1e1;
      .day {
        font-size: 15px;
        color: var(--font-color-1);
      }
      .year {
        font-size: 12px;
        color: var(--font-color-3);
      }
      &::before {
        content: '';
        position: absolute;
        right: -7px;
        top: 0;
        width: 13px;
        height: 13px;
        background: var(--bg-color-2);
      }
      &::after {
        content: '';
        position: absolute;
        right: -3px;
        top: 4px;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: var(--main-color-2);
      }
    }
    .right {
      flex: 1;
      padding-left: 12px;
      padding-bottom: 23px;
      .name-position {
        display: flex;
        align-items: center;
        .name {
          margin-right: 5px;
          font-size: 16px;
          font-weight: bold;
        }
      }
      .overweight {
        padding-top: 4px;
        line-height: 18px;
        font-size: 13px;
        color: var(--font-color-3);
      }
    }
    &:first-child {
      .dividing-lines {
        margin-top: 5px;
        .dot {
          top: 0;
        }
      }
    }
    &:last-child {
      .dividing-lines {
        height: 25px;
      }
      .shareholder-info {
        .overweight {
          padding-bottom: 0;
        }
      }
    }
  }
}
</style>
